// Game background: the same cream paper as the menu hero, from web-background.png, so the
// menu and the in-game world feel continuous (replaces the old procedural watercolor).
// Rendered once per resize into an offscreen canvas; falls back to a flat cream fill until
// the image loads.
import { G } from '../game/state';

export const CREAM = '#f8f1d6';

// Load the paper texture once; re-composite the background when it arrives.
const bgImg = new Image();
let bgReady = false;
bgImg.onload = () => {
  bgReady = true;
  makeBg();
};
bgImg.src = import.meta.env.BASE_URL + 'assets/web-background.png';

export function makeBg(): void {
  if (!G.W || !G.H) return;
  const bg = document.createElement('canvas');
  bg.width = G.W;
  bg.height = G.H;
  G.bgCanvas = bg;
  const b = bg.getContext('2d')!;
  b.fillStyle = CREAM;
  b.fillRect(0, 0, G.W, G.H);
  if (bgReady) {
    // cover-fit the paper texture across the viewport
    const s = Math.max(G.W / bgImg.naturalWidth, G.H / bgImg.naturalHeight);
    const dw = bgImg.naturalWidth * s;
    const dh = bgImg.naturalHeight * s;
    b.drawImage(bgImg, (G.W - dw) / 2, (G.H - dh) / 2, dw, dh);
  }
}
